var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    {
      attrs: { autocomplete: "off", id: "source_submit" },
      on: { submit: _vm.onSubmit }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-sm-12 col-md-12 col-lg-12" },
          [
            _c(
              "b-form",
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "ФИО", "label-for": "name" } },
                  [
                    _c("b-form-input", {
                      attrs: { id: "name", size: "sm", type: "text" },
                      model: {
                        value: _vm.user.name,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "name", $$v)
                        },
                        expression: "user.name"
                      }
                    }),
                    _vm._v(" "),
                    _vm.submitted && !_vm.user.name
                      ? _c("span", { staticClass: "alert-danger" }, [
                          _vm._v("Поле ФИО является обязательным.")
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  { attrs: { label: "Email", "label-for": "email" } },
                  [
                    _c("b-form-input", {
                      attrs: { id: "email", size: "sm", type: "text" },
                      model: {
                        value: _vm.user.email,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "email", $$v)
                        },
                        expression: "user.email"
                      }
                    }),
                    _vm._v(" "),
                    _vm.submitted && !_vm.user.email
                      ? _c("span", { staticClass: "alert-danger" }, [
                          _vm._v("Поле Email является обязательным.")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.submitted && _vm.message
                      ? _c("span", { staticClass: "alert-danger" }, [
                          _vm._v(_vm._s(_vm.message))
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  { attrs: { label: "Роль", "label-for": "role" } },
                  [
                    _c(
                      "b-form-select",
                      {
                        staticClass: "filterComponent",
                        attrs: { size: "sm" },
                        model: {
                          value: _vm.user.role,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "role", $$v)
                          },
                          expression: "user.role"
                        }
                      },
                      [
                        _c("option", { attrs: { value: "user" } }, [
                          _vm._v("Пользователь")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "leader" } }, [
                          _vm._v("Лидер")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "admin" } }, [
                          _vm._v("Админ")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "account" } }, [
                          _vm._v("Аккаунт")
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  {
                    attrs: { label: "Департамент", "label-for": "department" }
                  },
                  [
                    _c(
                      "b-form-select",
                      {
                        staticClass: "filterComponent",
                        attrs: { size: "sm" },
                        model: {
                          value: _vm.user.department,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "department", $$v)
                          },
                          expression: "user.department"
                        }
                      },
                      [
                        _c("option", { attrs: { value: "agency" } }, [
                          _vm._v("Agency")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "adkey" } }, [
                          _vm._v("AdKey")
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.user.role == "leader"
                  ? _c(
                      "b-form-group",
                      { attrs: { label: "Подчинённые", "label-for": "users" } },
                      [
                        _c(
                          "v-select",
                          {
                            attrs: {
                              options: _vm.availableUsers,
                              label: "name",
                              required: "",
                              multiple: ""
                            },
                            model: {
                              value: _vm.user.subordinates,
                              callback: function($$v) {
                                _vm.$set(_vm.user, "subordinates", $$v)
                              },
                              expression: "user.subordinates"
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                attrs: { slot: "no-options" },
                                slot: "no-options"
                              },
                              [_vm._v("Совпадений не найдено.")]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-6" },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Network ID",
                            "label-for": "network_partner_id"
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "network_partner_id",
                              size: "sm",
                              autocomplete: "off",
                              type: "number"
                            },
                            model: {
                              value: _vm.user.network_partner_id,
                              callback: function($$v) {
                                _vm.$set(_vm.user, "network_partner_id", $$v)
                              },
                              expression: "user.network_partner_id"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-6" },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Market ID",
                            "label-for": "market_partner_id"
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "market_partner_id",
                              size: "sm",
                              name: "market_partner_id",
                              role: "market_partner_id",
                              autocomplete: "off",
                              type: "number"
                            },
                            model: {
                              value: _vm.user.market_partner_id,
                              callback: function($$v) {
                                _vm.$set(_vm.user, "market_partner_id", $$v)
                              },
                              expression: "user.market_partner_id"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.user.role == "account"
                  ? _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-6" },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Affise Network API ID",
                                "label-for": "network_user_id"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "network_user_id",
                                  size: "sm",
                                  autocomplete: "off",
                                  type: "text"
                                },
                                model: {
                                  value: _vm.user.network_user_id,
                                  callback: function($$v) {
                                    _vm.$set(_vm.user, "network_user_id", $$v)
                                  },
                                  expression: "user.network_user_id"
                                }
                              }),
                              _vm._v(" "),
                              _vm.submitted && _vm.network_user_id_message
                                ? _c("span", { staticClass: "alert-danger" }, [
                                    _vm._v(_vm._s(_vm.network_user_id_message))
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-6" },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Affise Market API ID",
                                "label-for": "market_user_id"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "market_user_id",
                                  size: "sm",
                                  name: "market_user_id",
                                  role: "market_user_id",
                                  autocomplete: "off",
                                  type: "text"
                                },
                                model: {
                                  value: _vm.user.market_user_id,
                                  callback: function($$v) {
                                    _vm.$set(_vm.user, "market_user_id", $$v)
                                  },
                                  expression: "user.market_user_id"
                                }
                              }),
                              _vm._v(" "),
                              _vm.submitted && _vm.market_user_id_message
                                ? _c("span", { staticClass: "alert-danger" }, [
                                    _vm._v(_vm._s(_vm.market_user_id_message))
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("b-form-input", {
                  staticStyle: {
                    opacity: "0",
                    "max-width": "1px",
                    "max-height": "1px",
                    padding: "0!important"
                  },
                  attrs: { type: "text" }
                }),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  { attrs: { label: "Пароль", "label-for": "newPassword" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "newPassword",
                        size: "sm",
                        autocomplete: "new-password",
                        type: "password"
                      },
                      on: {
                        blur: function($event) {
                          return _vm.validateNewPassword()
                        }
                      },
                      model: {
                        value: _vm.newPassword,
                        callback: function($$v) {
                          _vm.newPassword = $$v
                        },
                        expression: "newPassword"
                      }
                    }),
                    _vm._v(" "),
                    _vm.newPasswordMessage
                      ? _c("span", { staticClass: "alert-danger" }, [
                          _vm._v(_vm._s(_vm.newPasswordMessage))
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("b-form-input", {
                  staticStyle: {
                    opacity: "0",
                    "max-width": "1px",
                    "max-height": "1px",
                    padding: "0!important"
                  },
                  attrs: { type: "text" }
                }),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: "Подтверждение пароля",
                      "label-for": "passwordRepeat"
                    }
                  },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "passwordRepeat",
                        size: "sm",
                        autocomplete: "new-password",
                        type: "password"
                      },
                      on: {
                        blur: function($event) {
                          return _vm.validateRepeatPassword()
                        }
                      },
                      model: {
                        value: _vm.passwordRepeat,
                        callback: function($$v) {
                          _vm.passwordRepeat = $$v
                        },
                        expression: "passwordRepeat"
                      }
                    }),
                    _vm._v(" "),
                    _vm.repeatPasswordMessage
                      ? _c("span", { staticClass: "alert-danger" }, [
                          _vm._v(_vm._s(_vm.repeatPasswordMessage))
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-dropdown",
                  {
                    staticClass: "float-right",
                    attrs: {
                      right: "",
                      variant: "primary",
                      split: "",
                      text: "Сохранить и выйти"
                    },
                    on: {
                      click: function($event) {
                        return _vm.onSubmit($event, true)
                      }
                    }
                  },
                  [
                    _c(
                      "b-dropdown-item",
                      {
                        on: {
                          click: function($event) {
                            return _vm.onSubmit($event, true)
                          }
                        }
                      },
                      [_vm._v("Сохранить и выйти")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-dropdown-item",
                      {
                        on: {
                          click: function($event) {
                            return _vm.onSubmit($event, false)
                          }
                        }
                      },
                      [_vm._v("Сохранить и создать")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-errors" })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-errors" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-adb2d23c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-adb2d23c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/front/modals/CreateUserModal.vue
// module id = 1024
// module chunks = 0